export var CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export var CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export var CREATE_ORDER_ERROR = 'CREATE_ORDER_ERROR';
export var FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export var FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export var FETCH_ORDERS_ERROR = 'FETCH_ORDERS_ERROR';
export var FETCH_ORDER_REQUEST = 'FETCH_ORDER_REQUEST';
export var FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';
export var FETCH_ORDER_ERROR = 'FETCH_ORDER_ERROR';
export var FETCH_ORDER_UNAUTHORIZED = 'FETCH_ORDER_UNAUTHORIZED';
